const benefits = [
  {
    icon: "ri-map-pin-2-line",
    title: "PH-Focused Support",
    text: "We understand local lenders, LTO processes, and the realities of car loans in the Philippines.",
    image:
      "https://public.readdy.ai/ai/img_res/2aaaf4441034530f3c0d82fffae0a33d.jpg",
  },
  {
    icon: "ri-timer-flash-line",
    title: "Fast Initial Assessment",
    text: "Get a clear picture of your options quickly. We know timing matters, especially when payments are tight.",
    image:
      "https://readdy.ai/api/search-image?query=Filipino%20young%20adult%20checking%20phone%20urgently%20at%20a%20table%20with%20papers%20and%20documents%20nearby%2C%20natural%20warm%20indoor%20light%20through%20window%2C%20candid%20moment%20looking%20focused%20and%20alert%2C%20slightly%20desaturated%20pastel%20tones%2C%20real%20everyday%20scene%20Southeast%20Asian%20not%20corporate%20staged&width=600&height=320&seq=benefit-card-ph-2&orientation=landscape",
  },
  {
    icon: "ri-shield-check-line",
    title: "Legal & Above Board",
    text: "Every path we recommend is compliant with Philippine law. We never advise shortcuts that increase your risk.",
    image:
      "https://readdy.ai/api/search-image?query=Southeast%20Asian%20professional%20carefully%20reading%20a%20legal%20contract%20document%20at%20a%20clean%20minimal%20desk%2C%20pen%20in%20hand%20pointing%20at%20the%20text%2C%20natural%20soft%20window%20light%20falling%20on%20papers%2C%20muted%20pastel%20tones%2C%20trustworthy%20composed%20moment%2C%20desaturated%20calm%20photography&width=600&height=320&seq=benefit-card-ph-3&orientation=landscape",
  },
  {
    icon: "ri-chat-private-line",
    title: "Discreet Communication",
    text: "Your situation stays private. We handle all conversations with professionalism and confidentiality.",
    image:
      "https://readdy.ai/api/search-image?query=Filipino%20person%20having%20a%20quiet%20private%20phone%20call%20at%20home%20seated%20near%20a%20window%2C%20calm%20composed%20expression%2C%20soft%20warm%20afternoon%20natural%20light%20filtering%20through%20curtains%2C%20desaturated%20pastel%20tones%2C%20candid%20private%20personal%20moment%2C%20real%20life%20authentic%20scene%20not%20staged&width=600&height=320&seq=benefit-card-ph-4&orientation=landscape",
  },
  {
    icon: "ri-compass-3-line",
    title: "Practical Guidance",
    text: "We don't just give you information — we walk you through what to do next and help where we can.",
    image:
      "https://readdy.ai/api/search-image?query=Two%20Filipino%20people%20sitting%20together%20at%20a%20small%20table%20reviewing%20documents%2C%20one%20person%20explaining%20while%20the%20other%20listens%20attentively%2C%20natural%20indoor%20lighting%2C%20collaborative%20supportive%20helpful%20moment%2C%20warm%20soft%20muted%20pastel%20tones%2C%20real%20life%20consultation%20scene%20Southeast%20Asian%20adults%20authentic&width=600&height=320&seq=benefit-card-ph-5&orientation=landscape",
  },
  {
    icon: "ri-group-line",
    title: "Buyer & Transfer Network",
    text: "Access to a network of qualified buyers and transfer-ready clients who can move quickly.",
    image:
      "https://readdy.ai/api/search-image?query=Filipino%20buyer%20and%20seller%20shaking%20hands%20with%20a%20regular%20everyday%20car%20visible%20behind%20them%20outdoors%2C%20both%20smiling%20and%20relaxed%2C%20natural%20daytime%20light%2C%20warm%20soft%20muted%20tones%2C%20authentic%20real%20life%20vehicle%20transaction%20moment%2C%20desaturated%20pastel%20photography%20genuine%20positive%20interaction&width=600&height=320&seq=benefit-card-ph-6&orientation=landscape",
  },
];

const stats = [
  { value: "500+", label: "Cases Reviewed" },
  { value: "3–5", label: "Days Avg. Assessment" },
  { value: "100%", label: "Legal Pathways Only" },
  { value: "Cebu", label: "HQ + Nationwide" },
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-20 lg:py-28" style={{ backgroundColor: "#F8FAFC" }}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p
            className="text-sm font-semibold uppercase tracking-widest"
            style={{ color: "#4F7CFF" }}
          >
            Why vehicle owners trust AutoManagement PH
          </p>
          <h2
            className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl"
            style={{ color: "#1E293B" }}
          >
            Built for this specific problem
          </h2>
          <p className="mt-4 text-base leading-7" style={{ color: "#475569" }}>
            Most people facing car loan stress don&apos;t know where to start.
            We exist to give you a clear, legal, and realistic path forward.
          </p>
        </div>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="rounded-xl overflow-hidden flex flex-col"
              style={{
                backgroundColor: "#FFFFFF",
                border: "1px solid #E8EEFF",
                boxShadow: "0 2px 12px rgba(79,124,255,0.06)",
              }}
            >
              <div className="w-full h-44 overflow-hidden flex-shrink-0">
                <img
                  src={b.image}
                  alt={b.title}
                  className="w-full h-full object-cover object-top"
                  style={{ filter: "saturate(0.75) brightness(1.02)" }}
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div
                  className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg"
                  style={{ backgroundColor: "#EBF0FF" }}
                >
                  <i className={`${b.icon} text-lg`} style={{ color: "#4F7CFF" }} />
                </div>
                <h3 className="mb-2 text-base font-bold" style={{ color: "#1E293B" }}>
                  {b.title}
                </h3>
                <p className="text-sm leading-7" style={{ color: "#475569" }}>
                  {b.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div
          className="mt-12 grid grid-cols-2 gap-6 rounded-xl p-8 lg:grid-cols-4"
          style={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #E8EEFF",
            boxShadow: "0 2px 12px rgba(79,124,255,0.06)",
          }}
        >
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div
                className="text-3xl font-black"
                style={{ color: "#4F7CFF" }}
              >
                {s.value}
              </div>
              <div className="mt-1 text-sm" style={{ color: "#475569" }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
